export default __webpack_public_path__ + "static/media/space_tracker_GUI.7ed99c10.jsfx";